// FAQ_Style.ts
import { styled, keyframes } from "@mui/system";

const expand = keyframes({
  from: {
    opacity: 0,
    transform: "translateY(-6px)",
  },
  to: {
    opacity: 1,
    transform: "translateY(0)",
  },
});

export const FAQWrapper = styled("div")(({ theme }) => ({
  margin: "0 auto",
  paddingBottom: "20px",
  width: "70%",

  [theme.breakpoints.down("sm")]: {
    width: "100%",
  },

  [theme.breakpoints.down("lg")]: {
    width: "100%",
  },
}));

export const FAQItem = styled("div")(() => ({
  background: "#fff",
  borderRadius: 12,
  boxShadow: "0 6px 20px rgba(0,0,0,0.06)",
  marginBottom: 16,
  overflow: "hidden",
}));

export const FAQQuestion = styled("div")(() => ({
  padding: "16px 20px",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  cursor: "pointer",
  fontWeight: 600,
  fontSize: 15,
  color: "#111827",

  "&:hover": {
    background: "#f9fafb",
  },
}));

export const FAQIcon = styled("div")<{ open: boolean }>(({ open }) => ({
  width: 14,
  height: 14,
  position: "relative",

  "&::before, &::after": {
    content: '""',
    position: "absolute",
    background: "#6b7280",
    transition: "all .25s ease",
  },

  "&::before": {
    width: "100%",
    height: 2,
    top: "50%",
    left: 0,
    transform: "translateY(-50%)",
  },

  "&::after": {
    width: 2,
    height: "100%",
    left: "50%",
    top: 0,
    transform: open ? "translateX(-50%) scaleY(0)" : "translateX(-50%)",
  },
}));

export const FAQAnswer = styled("div")(() => ({
  padding: "10px 20px 10px",
  fontSize: 14,
  lineHeight: 1.6,
  color: "#4b5563",
  animation: `${expand} .2s ease`,
}));
